import { useCallback } from 'react'

import {
  trans,
  TranslationKey,
  TranslationLanguage,
  TranslationTokenMap
} from 'i18n/translate'

export function useTranslation() {
  const language: TranslationLanguage = 'en' // hardcoded for now - eventually will come from context

  // callback isn't really necessary yet, but it will be once we add more languages
  // but leave this in place
  const translate = useCallback(
    (key: TranslationKey, values?: TranslationTokenMap) => {
      return trans(key, values, language)
    },
    [language]
  )

  return {
    language,
    trans: translate
  }
}
